import {
  FundingProgramAbbreviation,
  fundingProgramFilterExists,
  getFundingProgramProperties,
  updateFundingProgramSearchFilter,
} from "@outschool/funding-programs-shared";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { useFundingProgramAbbr } from "@outschool/ui-auth";
import { ToggleButton } from "@outschool/ui-legacy-component-library";
import React from "react";

import { useSearchFiltersFundingProgramAbbr } from "./utils";

export function useGetProgramForFundingProgramButton(searchFilters?: {
  fundingPrograms?: string[] | string | null;
}) {
  const searchFiltersFundingProgramAbbr =
    useSearchFiltersFundingProgramAbbr(searchFilters);
  const esaState = useFundingProgramAbbr();

  if (!!searchFiltersFundingProgramAbbr) {
    return getFundingProgramProperties(searchFiltersFundingProgramAbbr);
  } else {
    return getFundingProgramProperties(esaState);
  }
}

export function useShowFundingProgramButton(searchFilters?: SearchFiltersType) {
  return !!useGetProgramForFundingProgramButton(searchFilters);
}

export default function FundingProgramButton({
  updateSearchFilters,
  searchFilters,
}: {
  updateSearchFilters: (payload: SearchFiltersType) => void;
  searchFilters?: SearchFiltersType;
  searchUid?: string;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\FundingProgram\\FundingProgramButton",
  );

  const fundingProgramProperties =
    useGetProgramForFundingProgramButton(searchFilters);

  if (!fundingProgramProperties) {
    return null;
  }

  const label =
    fundingProgramProperties.abbreviation === FundingProgramAbbreviation.NC
      ? fundingProgramProperties.programNameAbbr
      : t("{{fundingProgramName}} Eligible", {
          fundingProgramName: fundingProgramProperties.programNameAbbr,
        });

  return (
    <ToggleButton
      size="small"
      enabled={fundingProgramFilterExists(searchFilters)}
      onClick={() => {
        updateSearchFilters({
          fundingPrograms: updateFundingProgramSearchFilter(
            searchFilters,
            fundingProgramProperties.abbreviation,
          ),
        });
      }}
    >
      {label}
    </ToggleButton>
  );
}
